import React from "react";
// images
import Image from "../assets/avatar.svg";

// icons

import {
  Fagithub,
  Fayoutube,
  FaDribble,
  FaYoutube,
  FaGithub,
  FaLinkedin,
} from "react-icons/fa";
// type animation
import { TypeAnimation } from "react-type-animation";
// motion
import { motion } from "framer-motion";

import { fadeIn } from "../variants";
const Banner = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          {/* text */}
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[55px] font-bold leading-[0.8] lg:text-[110px]"
            >
              WASI<span>UDDIN</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4">I am a</span>
              <TypeAnimation
                sequence={[
                  "Developer",
                  2000,
                  "Designer",
                  2000,
                  "Freelancer",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 max-w-lg mx-auto lg:mx-0"
            >
              I am a full stack web developer busy making projects and studying
              the deepest aspects of web development. I recently launched my
              portfolio website, which you are able to see on my website. I have
              put in my best efforts to make it responsive and user-friendly,
              and it is still under development. I will notify you all via email
              when it is fully ready. I am committed to keeping my clients and
              followers informed about my progress, and I believe that my
              dedication and expertise will help me succeed in the field of web
              development
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <button className="btn btn-lg">
                <a href="mailto:wasiforwork@gmail.com">Contact Me</a>
              </button>
              <a
                href="https://drive.google.com/file/d/1ioiXrDpxrdMhQx84qPaBWk2Ugck5Ey3N/view?usp=share_link"
                target="_blank"
                className="text-gradient btn-link"
              >
                My Portfolio
              </a>
            </motion.div>
            {/* socilas */}
            <motion.div
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <a href="#">
                <FaYoutube />
              </a>
              <a href="https://github.com/wasiuddinmansoori1">
                <FaGithub />
              </a>
              <a href="https://www.linkedin.com/in/wasiuddin-mansoori-203a5a237/">
                <FaLinkedin />
              </a>
            </motion.div>
          </div>
          {/* image */}
          <motion.div
            variants={fadeIn("down", 0.6)}
            initial="hidden"
            whileInView={"show"}
            className="hidden lg:flex flex-1 max-w-[320px]
          lg:max-w-[482px]"
          >
            <img src="#" alt="" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
